(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class TestimonialsCarousel extends HTMLElement {
    constructor() {
      super();
      this.track = null;
      this.previousButton = null;
      this.nextButton = null;
    }

    connectedCallback() {
      this.track = this.querySelector('[ref="track"]');
      this.previousButton = this.querySelector('[ref="previous"]');
      this.nextButton = this.querySelector('[ref="next"]');
      this.dots = Array.from(this.querySelectorAll('.testimonials-section__dot'));

      // Delegate clicks on the host element so the controls keep working even
      // after Horizon re-renders/morphs the section (which swaps the button nodes).
      // Guard so reconnecting the element doesn't bind the handler twice.
      if (!this._controlsBound) {
        this._controlsBound = true;
        this.addEventListener('click', (event) => {
          const control = event.target.closest('[ref="previous"], [ref="next"], .testimonials-section__dot');
          if (!control || !this.contains(control)) return;

          if (control.matches('[ref="previous"]')) {
            this.scrollByCard(-1);
          } else if (control.matches('[ref="next"]')) {
            this.scrollByCard(1);
          } else {
            const index = parseInt(control.dataset.index, 10) || 0;
            this.scrollToCard(index);
          }
        });
      }

      if (this.track) {
        this.track.addEventListener('scroll', () => {
          window.requestAnimationFrame(() => {
            this.updateActiveDot();
            this.updateActiveCard();
          });
        }, { passive: true });
      }

      this.scrollToInitialCard();
      this.updateActiveDot();
      this.updateActiveCard();
    }

    getCenteredCardIndex() {
      if (!this.track) return 0;
      const cards = this.track.querySelectorAll('.testimonials-section__card');
      if (!cards.length) return 0;
      const trackCenter = this.track.getBoundingClientRect().left + this.track.clientWidth / 2;
      let activeIndex = 0;
      let smallest = Infinity;
      cards.forEach((card, index) => {
        const rect = card.getBoundingClientRect();
        const cardCenter = rect.left + rect.width / 2;
        const distance = Math.abs(cardCenter - trackCenter);
        if (distance < smallest) {
          smallest = distance;
          activeIndex = index;
        }
      });
      return activeIndex;
    }

    updateActiveCard() {
      if (!this.track) return;
      const cards = this.track.querySelectorAll('.testimonials-section__card');
      if (!cards.length) return;
      const activeIndex = this.getCenteredCardIndex();
      cards.forEach((card, index) => {
        card.classList.toggle('is-active', index === activeIndex);
      });
    }

    scrollToCard(index) {
      if (!this.track) return;
      const cards = this.track.querySelectorAll('.testimonials-section__card');
      const target = cards[index];
      if (!target) return;
      const trackRect = this.track.getBoundingClientRect();
      const cardRect = target.getBoundingClientRect();
      const offset =
        this.track.scrollLeft +
        cardRect.left -
        trackRect.left -
        (trackRect.width - cardRect.width) / 2;
      this.track.scrollTo({ left: offset, behavior: 'smooth' });
    }

    updateActiveDot() {
      if (!this.track || !this.dots || !this.dots.length) return;
      const cards = this.track.querySelectorAll('.testimonials-section__card');
      if (!cards.length) return;
      const trackCenter = this.track.getBoundingClientRect().left + this.track.clientWidth / 2;
      let activeIndex = 0;
      let smallest = Infinity;
      cards.forEach((card, index) => {
        const rect = card.getBoundingClientRect();
        const cardCenter = rect.left + rect.width / 2;
        const distance = Math.abs(cardCenter - trackCenter);
        if (distance < smallest) {
          smallest = distance;
          activeIndex = index;
        }
      });
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    }

    scrollToInitialCard() {
      if (!this.track) return;
      const cards = this.track.querySelectorAll('.testimonials-section__card');
      if (cards.length < 2) return;

      const scroll = () => {
        const second = cards[1];
        if (!second) return;
        const trackRect = this.track.getBoundingClientRect();
        const cardRect = second.getBoundingClientRect();
        const offset =
          this.track.scrollLeft +
          cardRect.left -
          trackRect.left -
          (trackRect.width - cardRect.width) / 2;
        this.track.scrollTo({ left: offset, behavior: 'auto' });
      };

      if (document.readyState === 'complete') {
        scroll();
      } else {
        window.addEventListener('load', scroll, { once: true });
      }
    }

    scrollByCard(direction) {
      if (!this.track) return;
      const card = this.track.querySelector('.testimonials-section__card');
      if (!card) return;
      const style = getComputedStyle(this.track);
      const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      const isRTL = style.direction === 'rtl';
      const distance = card.getBoundingClientRect().width + gap;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;

      // In RTL, scrollLeft is negative (0 at the right edge, going negative
      // toward the end). Work with the absolute scroll magnitude so the
      // logic is identical in both directions, then re-sign at the end.
      const current = Math.abs(this.track.scrollLeft);
      let magnitude = current + distance * direction;

      if (direction > 0 && current >= maxScroll - 2) {
        magnitude = 0;
      } else if (direction < 0 && current <= 2) {
        magnitude = maxScroll;
      }

      magnitude = Math.max(0, Math.min(magnitude, maxScroll));
      const target = isRTL ? -magnitude : magnitude;

      this.track.scrollTo({ left: target, behavior: 'smooth' });
    }
  }

  if (!customElements.get('testimonials-carousel')) {
    customElements.define('testimonials-carousel', TestimonialsCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
